export const environment = {
  production: true,
  name: "prod",
  basePath:"https://a23j5pz2ka.execute-api.eu-west-1.amazonaws.com/prod/fas/rest/api/v0"
};
